import { useEffect, useState } from 'react';
import { usePathname } from '@/navigation';
import { useIsDesktop } from './useIsDesktop';

export const useChatbotVisibility = () => {
  const pathname = usePathname();
  const isDesktop = useIsDesktop();
  const [isDisabled, setIsDisabled] = useState(true);
  const region: string = process.env.NEXT_PUBLIC_REGION as string;
  const whatsAppRegions: Set<string> = new Set(['EU', 'UK']);
  const enabledWhatsApp: boolean = whatsAppRegions.has(region);
  // disabledPagesOverride absolute override zendesk for these pages:
  const disabledPagesOverride: string[] = ['product-recalls'];
  const isDisabledPage = disabledPagesOverride.some((url) =>
    pathname?.includes(url),
  );
  const loadChatForMobilePaths: string[] = ['/account', '/pages/help'];
  const loadForMobile = loadChatForMobilePaths.reduce((prev, current) => {
    if (enabledWhatsApp) return [...prev, current];
    if (pathname === '/') return prev;
    return pathname?.includes(current) ? [...prev, current] : prev;
  }, [] as string[]);

  /*
    live chat widget is enabled only for
    - US only
    - all desktop pages
    - only certain mobile pages, as denoted in the loadChatForMobilePaths array.
    - can be disabled on a store basis by revoking the env variable value.

    whatsapp is for EU/UK only and is enabled for all pages/device type

    ** - disabledPagesOverride overrides a page for desktop and mobile
  */
  useEffect(() => {
    setIsDisabled(isDisabledPage || (!isDesktop && !loadForMobile.length));
  }, [pathname, isDesktop, loadForMobile, isDisabledPage]);
  return { isDisabled, isDesktop };
};
